<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'TextareaObj',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'maxlength', 'id', 'type', 'dense', 'objkey'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field][this.objkey]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { obj: this.field, key: this.objkey, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-textarea
    outlined
    class="py-0 my-0"
    v-model="model"
    :dense="dense"
    :id="id"
    :maxlength="maxlength || 64"
    :placeholder="placeholder"
    :rules="rules"
    :label="label"
    :type ="type || 'text'"
    height="75"
  ></v-textarea>
</template>
